<template>
    <div class="guide-footer">
        <div class="content">
            <a @click="$emit('share')" :class="{ isEN }">
                {{ shareBtnText || _lang('shareBtnText').replace(/\{name\}/, _lang(`names.${channel}`)) }}
            </a>
        </div>
        <div class="bottom">
            <div class="text">
                {{
                    _lang(currentShareMethod === ShareMethod.TO_HOME ? 'bottomTextWhenToHome' : 'bottomTextWhenToEdit')
                }}
            </div>
        </div>
    </div>
</template>

<script >
// 引导页底部
import { use } from '@fegobull/webapi';
import { computed } from 'vue-demi';
import { _lang, currentLanguage } from '../common/lang';
import { Language, ShareMethod } from '../common/type';
const __sfc_main = {};
__sfc_main.props = {
  channel: {
    type: String,
    default: ''
  },
  currentShareMethod: {
    type: String,
    default: ''
  },
  shareBtnText: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = use;
  !window.FEGOEditor && useTeleport(document.body);
  const isEN = computed(() => {
    return currentLanguage.value === Language.EN;
  });
  return {
    _lang,
    ShareMethod,
    isEN
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.guide-footer {
    width: 7.5rem;
    padding: 0.3rem 0.32rem 0;
    height: 2rem;
    background: rgba(30, 30, 30, 0.88);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    z-index: 9;

    .content {
        display: flex;
        justify-content: center;
    }
    .tip {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #d7d7d7;
        font-size: 0.18rem;
        gap: 0.06rem;

        img {
            width: 1.14rem;
            height: 0.64rem;
            flex-shrink: 0;
        }
    }

    a {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 1.18rem;
        background: #ff6900;
        padding: 0.22rem 0.62rem 0.22rem 0.64rem;
        color: #fff;
        font-size: 0.38rem;
        font-style: normal;
        font-weight: 600;
        line-height: 146.4%;
        width: 100%;
        &.isEN {
            min-width: 4.76rem;
        }
    }
    .bottom {
        height: 0.7rem;
        .text {
            padding-top: 0.1rem;
            text-align: center;
            font-size: 0.24rem;
            color: #9a9a9a;
        }
    }
}
</style>
